import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, Messaging } from 'firebase/messaging';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private messaging: Messaging;

  constructor() {
    // Initialise Firebase avec ta config
    const app = initializeApp(environment.firebase);
    this.messaging = getMessaging(app);
  }

  /**
   * Demande la permission utilisateur et récupère un token FCM valide
   * Compatible iOS PWA (Safari ≥ 16.4) & Android
   */
  async requestPermissionAndStoreToken(): Promise<void> {
    try {
      // 1️⃣ Demande explicite la permission (obligatoire sur iOS/Android)
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.warn('❌ Permission de notification refusée par l’utilisateur');
        return;
      }

      // 2️⃣ Enregistre le Service Worker FCM (doit être à la racine du domaine)
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      console.info('✅ Service Worker FCM enregistré', registration);

      // 3️⃣ Récupère le token FCM lié à ce Service Worker
      const token = await getToken(this.messaging, {
        vapidKey: environment.firebase.vapidKey,
        serviceWorkerRegistration: registration
      });

      if (token) {
        console.info('✅ FCM Token obtenu :', token);
        localStorage.setItem('fcmToken', token);
      } else {
        console.warn('⚠️ Aucun token obtenu. Vérifie la config Firebase ou les permissions.');
      }

    } catch (err) {
      console.error('❌ Erreur lors de la demande de permission / récupération du token FCM :', err);
    }
  }

  /**
   * Récupère le token FCM stocké
   */
  getFcmToken(): string | undefined {
    return localStorage.getItem('fcmToken') ?? undefined;
  }

  /**
   * Supprime le token FCM local
   */
  clearFcmToken(): void {
    localStorage.removeItem('fcmToken');
  }
}
